import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaMapMarkerAlt, FaPhone, FaClock, FaUserMd, FaHospital } from "react-icons/fa";
import { MdEmail, MdMedicalServices } from "react-icons/md";
import { Helmet } from "react-helmet";
import "./ClinicDetail.scss";

// Dummy data for clinics
const clinicData = {
  "wakad": {
    name: "AxonCare Global Multispecialty Clinic",
    address: "WBIZ shop 114, near GINGER PUNE, Wakad, Pune, Pimpri-Chinchwad, Maharashtra 411057",
    phone: "8956652831",
    email: "wakad@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/5nwcobr97Ej8C3iN8",
    hours: "Mon-Sat: 9:00 AM - 8:00 PM, Sun: 10:00 AM - 4:00 PM",
    description: "Our state-of-the-art Wakad clinic is equipped with the latest medical technology and staffed by experienced healthcare professionals. We offer a wide range of services from routine check-ups to specialized consultations.",
    facilities: ["Virtual Consultations", "Laboratory Services", "Specialist Referrals", "Electronic Health Records", "Pharmacy Access"],
    doctors: [
      { name: "Dr. Anita Sharma", specialty: "General Physician", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Sharma" },
      { name: "Dr. Rajesh Patel", specialty: "Cardiologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Patel" },
      { name: "Dr. Meena Gupta", specialty: "Pediatrician", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Gupta" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Reception+Area",
      "https://placehold.co/800x500/f6f2e5/333?text=Consultation+Room",
      "https://placehold.co/800x500/f6f2e5/333?text=Health+Kiosk"
    ],
    type: "Owned"
  },
  "dahisar": {
    name: "AxonCare Global Multispecialty Clinic",
    address: "Mehta Clinic, Building No.5, Shop No.8, Shri Harsh CHSL, Near Metro Station, Dahisar East, Mumbai 400068",
    phone: "8956652834",
    email: "dahisar@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/zAq5Y2X5q5Mugzn79",
    hours: "Mon-Sat: 8:00 AM - 9:00 PM, Sun: 9:00 AM - 5:00 PM",
    description: "Located in the heart of Mumbai, our Dahisar clinic provides premium healthcare services in a modern, comfortable environment. Our team of specialists is committed to delivering personalized care to meet your health needs.",
    facilities: ["Virtual Consultations", "Diagnostic Services", "Preventive Health Checks", "Corporate Health Programs", "Wellness Counseling"],
    doctors: [
      { name: "Dr. Vikram Singh", specialty: "Internal Medicine", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Singh" },
      { name: "Dr. Priya Mehta", specialty: "Dermatologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Mehta" },
      { name: "Dr. Sanjay Kumar", specialty: "Orthopedic", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Kumar" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Modern+Facility",
      "https://placehold.co/800x500/f6f2e5/333?text=Waiting+Area",
      "https://placehold.co/800x500/f6f2e5/333?text=Treatment+Room"
    ],
    type: "Owned"
  },
  "nirogitanman": {
    name: "Nirogitanman Clinic",
    address: "SCF 19, Upper Ground Floor, Uptown Insignia, PR7 Airport Road, Zirakpur, Mohali- 140603",
    phone: "9216555667",
    email: "nirogitanman@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/hhHvu24LpJQqWHX38",
    hours: "Mon-Sat: 9:00 AM - 7:00 PM, Sun: 10:00 AM - 3:00 PM",
    description: "Managed by Ms. Indu Agarwal, Nirogitanman Clinic offers accessible, high-quality healthcare services. We focus on preventive care and patient education to help you maintain optimal health.",
    facilities: ["Virtual Consultations", "Primary Care", "Women's Health Services", "Vaccination", "Health Education"],
    doctors: [
      { name: "Ms. Indu Agarwal", specialty: "Healthcare Management", image: "https://placehold.co/200x200/f6f2e5/333?text=Ms.+Agarwal" },
      { name: "Dr. Anjali Joshi", specialty: "Gynecologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Joshi" },
      { name: "Dr. Rahul Verma", specialty: "ENT Specialist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Verma" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Clinic+Entrance",
      "https://placehold.co/800x500/f6f2e5/333?text=Patient+Room",
      "https://placehold.co/800x500/f6f2e5/333?text=Medical+Equipment"
    ],
    type: "Franchisee"
  },
  "shivam": {
    name: "Shivam Multispecility Hospital",
    address: "Opp. Riverview City, Near Loni Toll Naka, Solapur - Pune Hwy, Haveli, Taravadi, Phursungi, Maharashtra 412308",
    phone: "8042754125",
    email: "shivam@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/k8gYYo1aZEWjHiSy6",
    hours: "Mon-Fri: 9:00 AM - 6:00 PM, Sat: 9:00 AM - 2:00 PM",
    description: "Under the management of Dr. Rahul Kalbhor, Shivam Multispeciality Hospital provides comprehensive healthcare services. We are equipped with modern facilities to ensure high-quality medical care for all patients.",
    facilities: ["Multispecialty Care", "Telemedicine", "Diagnostics", "Emergency Services", "Inpatient Care"],
    doctors: [
      { name: "Dr. Rahul Kalbhor", specialty: "Medical Director", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Kalbhor" },
      { name: "Dr. Lakshmi Iyer", specialty: "Community Health", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Iyer" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Hospital+Entrance",
      "https://placehold.co/800x500/f6f2e5/333?text=Patient+Ward",
      "https://placehold.co/800x500/f6f2e5/333?text=Emergency+Room"
    ],
    type: "Franchisee"
  },
  "dhanwantari": {
    name: "Dhanwantari Skin Hair Laser Clinic",
    address: "Shop No. 4&5, Shree Residency, Narhe, Pune - 411049",
    phone: "7410138030",
    email: "dhanwantari@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/3Emh1rH8eWUp3ron8",
    hours: "Mon-Sat: 8:30 AM - 8:30 PM, Sun: 9:00 AM - 4:00 PM",
    description: "Led by Dr. Sudarshan Pawar, our clinic specializes in skin and hair treatments using advanced laser technology. We provide personalized care for all dermatological concerns.",
    facilities: ["Skin Treatments", "Hair Treatments", "Laser Procedures", "Dermatological Consultations", "Cosmetic Procedures"],
    doctors: [
      { name: "Dr. Sudarshan Pawar", specialty: "Dermatologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Pawar" },
      { name: "Dr. Deepa Kulkarni", specialty: "Cosmetologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Kulkarni" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Clinic+Front",
      "https://placehold.co/800x500/f6f2e5/333?text=Treatment+Room",
      "https://placehold.co/800x500/f6f2e5/333?text=Laser+Equipment"
    ],
    type: "Franchisee"
  },
  "sanjeevani": {
    name: "Sanjeevani Clinic",
    address: "Sanjeevani Clinic, Bhumkar Nagar, infront of Silver Birch Multispeciality Hospital",
    phone: "9561741141",
    email: "sanjeevani@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/BJkT8AoVCymvH63i6",
    hours: "Mon-Sat: 9:00 AM - 7:00 PM, Sun: By Appointment",
    description: "Under the care of Dr. Shankar Jadhav, Sanjeevani Clinic offers comprehensive healthcare services to the local community. We specialize in family medicine and primary care.",
    facilities: ["Family Medicine", "Primary Care", "Preventive Healthcare", "Chronic Disease Management", "Health Education"],
    doctors: [
      { name: "Dr. Shankar Jadhav", specialty: "Family Medicine", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Jadhav" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Clinic+View",
      "https://placehold.co/800x500/f6f2e5/333?text=Waiting+Area",
      "https://placehold.co/800x500/f6f2e5/333?text=Examination+Room"
    ],
    type: "Franchisee"
  },
  "shraddha": {
    name: "Shraddha Hospital",
    address: "Shraddha Hospital, Rajgad Complex, 1st Floor, Nasarapur, Tal: Bhor, Dist: Pune",
    phone: "18002101999",
    email: "shraddha@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/6LWX3HWU1pegJv5Z8",
    hours: "Mon-Sat: 9:00 AM - 8:00 PM, Sun: 10:00 AM - 2:00 PM",
    description: "Led by Dr. Shivraj Petkar, Shraddha Hospital provides comprehensive medical care to the Nasarapur community. We offer a range of services from primary care to specialized treatments.",
    facilities: ["Hospital Services", "Primary Care", "Emergency Services", "Laboratory", "Pharmacy"],
    doctors: [
      { name: "Dr. Shivraj Petkar", specialty: "Medical Director", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Petkar" },
      { name: "Dr. Priya Desai", specialty: "General Medicine", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Desai" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Hospital+Front",
      "https://placehold.co/800x500/f6f2e5/333?text=Reception",
      "https://placehold.co/800x500/f6f2e5/333?text=Patient+Care"
    ],
    type: "Franchisee"
  },
  "bkc": {
    name: "AxonCare BKC",
    address: "G Block-12th floor Crescenzo, BKC, Mumbai",
    phone: "+91 9876543211",
    email: "bkc@axoncare.in",
    mapUrl: "https://maps.app.goo.gl/wywvyLD5mQxPsgmc6",
    hours: "Mon-Sat: 8:00 AM - 9:00 PM, Sun: 9:00 AM - 5:00 PM",
    description: "Located in the heart of Mumbai's business district, our BKC clinic provides premium healthcare services in a modern, comfortable environment. Our team of specialists is committed to delivering personalized care to meet your health needs.",
    facilities: ["Virtual Consultations", "Diagnostic Services", "Preventive Health Checks", "Corporate Health Programs", "Wellness Counseling"],
    doctors: [
      { name: "Dr. Vikram Singh", specialty: "Internal Medicine", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Singh" },
      { name: "Dr. Priya Mehta", specialty: "Dermatologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Mehta" },
      { name: "Dr. Sanjay Kumar", specialty: "Orthopedic", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Kumar" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Modern+Facility",
      "https://placehold.co/800x500/f6f2e5/333?text=Waiting+Area",
      "https://placehold.co/800x500/f6f2e5/333?text=Treatment+Room"
    ],
    type: "Owned"
  },
  "narhe": {
    name: "AxonCare Narhe",
    address: "Narhe, Pune, Maharashtra 411046",
    phone: "+91 9876543212",
    email: "narhe@axoncare.in",
    mapUrl: "https://g.co/kgs/62bmRkv",
    hours: "Mon-Sat: 9:00 AM - 7:00 PM, Sun: 10:00 AM - 3:00 PM",
    description: "Our Narhe clinic serves the local community with accessible, high-quality healthcare services. We focus on preventive care and patient education to help you maintain optimal health.",
    facilities: ["Virtual Consultations", "Primary Care", "Women's Health Services", "Vaccination", "Health Education"],
    doctors: [
      { name: "Dr. Sunil Desai", specialty: "Family Medicine", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Desai" },
      { name: "Dr. Anjali Joshi", specialty: "Gynecologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Joshi" },
      { name: "Dr. Rahul Verma", specialty: "ENT Specialist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Verma" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Clinic+Entrance",
      "https://placehold.co/800x500/f6f2e5/333?text=Patient+Room",
      "https://placehold.co/800x500/f6f2e5/333?text=Medical+Equipment"
    ],
    type: "Owned"
  },
  "nasrapur": {
    name: "AxonCare Nasrapur",
    address: "Rajgad Complex, Nasrapur, Maharashtra 412213",
    phone: "+91 9876543213",
    email: "nasrapur@axoncare.in",
    mapUrl: "https://g.co/kgs/yjrcJdE",
    hours: "Mon-Fri: 9:00 AM - 6:00 PM, Sat: 9:00 AM - 2:00 PM",
    description: "Serving the rural community of Nasrapur, our clinic brings quality healthcare closer to home. We provide essential medical services and telemedicine consultations to ensure healthcare accessibility for all.",
    facilities: ["Rural Health Services", "Telemedicine", "Basic Diagnostics", "Maternal Health", "First Aid"],
    doctors: [
      { name: "Dr. Prakash Rao", specialty: "General Medicine", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Rao" },
      { name: "Dr. Lakshmi Iyer", specialty: "Community Health", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Iyer" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Rural+Clinic",
      "https://placehold.co/800x500/f6f2e5/333?text=Community+Outreach",
      "https://placehold.co/800x500/f6f2e5/333?text=Medical+Camp"
    ],
    type: "Owned"
  },
  "chinchwad": {
    name: "AxonCare Chinchwad",
    address: "WBIZ shop 114, Wakad, Pimpri-Chinchwad, Maharashtra 411057",
    phone: "+91 9876543214",
    email: "chinchwad@axoncare.in",
    mapUrl: "https://g.co/kgs/WdW4HcE",
    hours: "Mon-Sat: 8:30 AM - 8:30 PM, Sun: 9:00 AM - 4:00 PM",
    description: "Our Chinchwad clinic provides comprehensive healthcare services to the industrial township area. With advanced diagnostic facilities and specialists, we offer complete healthcare solutions for individuals and families.",
    facilities: ["Comprehensive Health Checks", "Industrial Health Services", "Advanced Diagnostics", "Specialist Consultations", "Health Insurance Support"],
    doctors: [
      { name: "Dr. Nitin Shah", specialty: "Pulmonologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Shah" },
      { name: "Dr. Deepa Kulkarni", specialty: "Diabetologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Kulkarni" },
      { name: "Dr. Arun Patil", specialty: "Neurologist", image: "https://placehold.co/200x200/f6f2e5/333?text=Dr.+Patil" }
    ],
    images: [
      "https://placehold.co/800x500/f6f2e5/333?text=Industrial+Clinic",
      "https://placehold.co/800x500/f6f2e5/333?text=Diagnostic+Center",
      "https://placehold.co/800x500/f6f2e5/333?text=Consulting+Room"
    ],
    type: "Owned"
  }
};

  // App store links
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.axoncare&pli=1";
  const appStoreLink = "https://apps.apple.com/in/app/axoncare/id6544802987";

const handleAppRedirect = (e) => {
  e.preventDefault();
  
  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  
  if (isMobile) {
    if (isAndroid) {
      window.open(playStoreLink, '_blank');
    } else {
      window.open(appStoreLink, '_blank');
    }
  } else {
    window.open("https://axoncare.axonichealth.co.in/login", '_blank');
  }
};

const ClinicDetail = () => {
  const { clinicId } = useParams();
  const clinic = clinicData[clinicId] || clinicData.wakad; // Default to Wakad if not found

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{clinic.name} | AxonCare Virtual Clinic</title>
        <meta
          name="description"
          content={`Visit ${clinic.name} for world-class healthcare services. ${clinic.description.substring(0, 100)}...`}
        />
      </Helmet>
      
      <div className="clinic-detail-parent parent">
        {/* Hero Section */}
        <div className="clinic-hero-section">
          <div className="container">
            <h1 data-aos="fade-up">{clinic.name}</h1>
            <p className="clinic-tagline" data-aos="fade-up" data-aos-delay="200">
              Advanced Healthcare at Your Convenience
            </p>
          </div>
        </div>
        
        {/* Clinic Overview */}
        <div className="clinic-overview-section">
          <div className="container">
            <div className="clinic-overview-grid">
              <div className="clinic-overview-left" data-aos="fade-right">
                <h2>About This Clinic</h2>
                <p>{clinic.description}</p>
                
                <div className="clinic-contact-info">
                  <div className="info-item">
                    <div className="icon"><FaMapMarkerAlt /></div>
                    <div className="content">
                      <h4>Address</h4>
                      <p>{clinic.address}</p>
                      <a href={clinic.mapUrl} target="_blank" rel="noopener noreferrer" className="map-link">
                        View on Map
                      </a>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <div className="icon"><FaPhone /></div>
                    <div className="content">
                      <h4>Phone</h4>
                      <p>{clinic.phone}</p>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <div className="icon"><MdEmail /></div>
                    <div className="content">
                      <h4>Email</h4>
                      <p>{clinic.email}</p>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <div className="icon"><FaClock /></div>
                    <div className="content">
                      <h4>Working Hours</h4>
                      <p>{clinic.hours}</p>
                    </div>
                  </div>
                  
                  <div className="info-item">
                    <div className="icon"><FaHospital /></div>
                    <div className="content">
                      <h4>Clinic Type</h4>
                      <p>{clinic.type}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="clinic-overview-right" data-aos="fade-left">
                <div className="clinic-image-main">
                  <iframe 
                    src={`https://maps.google.com/maps?q=${encodeURIComponent(clinic.address)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                    width="100%" 
                    height="450" 
                    style={{ border: 0, borderRadius: "8px" }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title={`Map location for ${clinic.name}`}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Facilities Section */}
        {/* <div className="clinic-facilities-section">
          <div className="container">
            <h2 data-aos="fade-up">Our Facilities</h2>
            <div className="facilities-grid" data-aos="fade-up" data-aos-delay="200">
              {clinic.facilities.map((facility, index) => (
                <div className="facility-card" key={index}>
                  <div className="facility-icon">
                    <MdMedicalServices />
                  </div>
                  <h3>{facility}</h3>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        
        {/* Gallery Section */}
        {/* <div className="clinic-gallery-section">
          <div className="container">
            <h2 data-aos="fade-up">Clinic Gallery</h2>
            <div className="gallery-grid" data-aos="fade-up" data-aos-delay="200">
              {clinic.images.map((image, index) => (
                <div className="gallery-item" key={index}>
                  <img src={image} alt={`${clinic.name} Interior ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div> */}
        
        {/* Doctors Section */}
        {/* <div className="clinic-doctors-section">
          <div className="container">
            <h2 data-aos="fade-up">Our Doctors</h2>
            <div className="doctors-grid" data-aos="fade-up" data-aos-delay="200">
              {clinic.doctors.map((doctor, index) => (
                <div className="doctor-card" key={index}>
                  <div className="doctor-image">
                    <img src={doctor.image} alt={doctor.name} />
                  </div>
                  <h3>{doctor.name}</h3>
                  <p>{doctor.specialty}</p>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        
        {/* Book Appointment CTA */}
        <div className="clinic-cta-section">
          <div className="container">
            <div className="cta-content" data-aos="fade-up">
              <h2>Schedule Your Appointment Today</h2>
              <p>Experience the future of healthcare with our virtual consultation services</p>
              <button className="cta-btn" onClick={handleAppRedirect}>Book Appointment</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClinicDetail; 